// NOTE:  This file is in the common folder but is no longer used by the client platform.
//        It is still used by the advisor platform and will remain in the common folder until that
//        is no longer the case.
export default class FooterSettings {
  constructor() {
    this.menu = [];
  }
}
